import { useTranslation } from "react-i18next";
import { SimulationBoard } from "./SimulationBoard";
import { lt } from "../localize";
import type { LessonStage } from "../types";

interface StageSimulationProps {
  stage: LessonStage;
}

export const StageSimulation = ({ stage }: StageSimulationProps) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const isAdjusted = stage.type === "simulation_adjust";

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-bold">{lt(stage.title, lang)}</h2>
      <p className="text-sm text-muted-foreground leading-relaxed">
        {lt(stage.content, lang)}
      </p>

      {stage.simulation && (
        <SimulationBoard
          simulation={stage.simulation}
          isAdjusted={isAdjusted}
        />
      )}
    </div>
  );
};
